import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoVoucherAction, 
  setIsFetching, 
  setFetchFailed, 
  setVoucherContent,
} from 'Pages/InfoVoucherPage/Redux/actions';

export const fetchVoucherContent = () => {
  return async (dispatch: Dispatch<InfoVoucherAction>): Promise<void> => {
    const { isFetching, content } = Store.getState().infoVoucher;

    if (isFetching || content) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('VoucherPage');

      if (response.status === 200) {
        const newContent: Julius.Content.VoucherPage = await response.json();
        dispatch(setVoucherContent(newContent));
      } else {
        dispatch(setFetchFailed());
      }

    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/pages/InfoVoucherPage/Redux/thunks.tsx